// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__332r4","Small":"Logo_Small__5iW8L","Medium":"Logo_Medium__lclwj","Large":"Logo_Large__YlBjy"};